import { render, staticRenderFns } from "./ReferenceLists.vue?vue&type=template&id=b34f3a92&scoped=true"
import script from "./ReferenceLists.vue?vue&type=script&lang=js"
export * from "./ReferenceLists.vue?vue&type=script&lang=js"
import style0 from "./ReferenceLists.vue?vue&type=style&index=0&id=b34f3a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34f3a92",
  null
  
)

export default component.exports